import moment from 'moment'

export const formatISOTime = (timestring = '', format = 'DD/MM/YY', ignoreTimezone = true) => {
  if (ignoreTimezone) {
    return moment(timestring.replace('Z', '')).format(format)
  }
  return moment(timestring).format(format)
}
